import { useQuery, gql } from "@apollo/client"

const ROLES_QUERY = gql`
  query {
    roles {
      id
      name
      friendlyName
      description
      isCustom
    }
  }
`

const useQueryRoles = () => useQuery(ROLES_QUERY)

export { useQueryRoles }
